import GradientButton from './GradientButton';

export default GradientButton;
